import { unitMapping } from '@sorare/core/src/lib/style';

type Props = {
  size?: keyof typeof unitMapping;
  className?: string;
};

export const Shoe = ({ size = 2, className }: Props) => {
  return (
    <svg
      style={{ width: unitMapping[size], height: unitMapping[size] }}
      viewBox="0 0 11 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.262304 5.0752L1.84923 1L2.59585 1.29074L3.69517 3.04034L5.09438 2.65744L5.09276 2.65182L5.64493 2.47809L7.34457 3.13995L7.28971 3.15515L8.43046 4.80359L7.27569 5.24714L7.66529 6.26145L9.0668 5.72312L10.2939 7.49636L9.7917 8.78606L8.65981 8.34528L8.47861 8.81059L7.54076 9.22273L7.12861 8.28488L7.30981 7.81958L4.54226 6.74186L4.36106 7.20719L3.42321 7.61934L3.01106 6.68149L3.19226 6.21616L2.51725 5.9533L2.33604 6.41865L1.39818 6.8308L0.986034 5.89294L1.16725 5.42759L0.262304 5.0752Z"
        fill="currentColor"
      />
    </svg>
  );
};
